import axios from 'axios';

// Configure axios to use the API base URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// Add authorization token to all requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// מודל התפקידים החדש (P5) — חייב להתאים ל-enum Role בבקאנד (מספרי)
export enum Role {
  Manager = 1,
  Employee = 2,
  Agent = 3,
}

export const roleLabel = (role: Role): string => {
  switch (role) {
    case Role.Manager: return 'מנהל';
    case Role.Agent: return 'סוכן';
    default: return 'עובד';
  }
};

export interface UserDto {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  // מודל חדש (P5)
  role: Role;
  roleName: string;
  canViewClientFinance: boolean;
  canViewFinancialReports: boolean;
  departmentIds: number[];
  departmentNames: string[];
  isActive: boolean;
  // P8a: מקושר לרשומה בספריית הסוכנים/ארגונים — אם כן, שם המשתמש מנוהל שם ולכן read-only בטופס
  isDirectoryLinked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserDto {
  fullName: string;
  email: string;
  phone: string;
  role: Role;
  canViewClientFinance: boolean;
  canViewFinancialReports: boolean;
  departmentIds: number[];
  password: string;
}

export interface UpdateUserDto {
  fullName: string;
  email: string;
  phone: string;
  role: Role;
  isActive: boolean;
  canViewClientFinance: boolean;
  canViewFinancialReports: boolean;
  departmentIds: number[];
}

export const usersApi = {
  getSalesReps: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users/sales-reps');
    return response.data;
  },

  // P6: unified staff list (Manager + Employee) — for assigning/reassigning scheduled items and the calendar
  // per-employee filter. Optional server-side search by name/email.
  getStaff: async (search?: string): Promise<UserDto[]> => {
    const response = await axios.get('/users/staff', { params: search ? { search } : undefined });
    return response.data;
  },

  getAll: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users');
    return response.data;
  },

  getById: async (id: number): Promise<UserDto> => {
    const response = await axios.get(`/users/${id}`);
    return response.data;
  },

  create: async (payload: CreateUserDto): Promise<UserDto> => {
    const response = await axios.post('/users', payload);
    return response.data;
  },

  update: async (id: number, payload: UpdateUserDto): Promise<UserDto> => {
    const response = await axios.put(`/users/${id}`, payload);
    return response.data;
  },

  resetPassword: async (id: number, newPassword: string): Promise<void> => {
    await axios.post(`/users/${id}/reset-password`, { newPassword });
  },

  remove: async (id: number): Promise<{ message?: string; wasDeactivated?: boolean }> => {
    const response = await axios.delete(`/users/${id}`);
    return response.data ?? {};
  },
};